interface BHAlertSpanProps {
  className?: string
  children: React.ReactElement
}

function BHAlertSpan({ className, children }: BHAlertSpanProps) {
  return (
    <span
      className={`${
        className ? className : ''
      }text-sm bg-yellow-200 p-2 border border-black rounded-md`}
    >
      {children}
    </span>
  )
}

export default BHAlertSpan
